import { structureModule } from '../../../shared/redux';
import { Structure } from '../../../shared/models';
import { WithDatasFetching } from '../../../shared/hocs';
import { structureService } from '../../../shared/services';

const enhancer = WithDatasFetching<Structure>(structureModule, structureService.get);
export default enhancer;
